import { CoursesCourseStatus } from '@sportspredict/shared';
import { coursesApi } from './courses-base.api';
import type {
	ListCoursesInput,
	ListCoursesOutput,
	GetCourseInput,
	GetCourseOutput,
} from '../../types/courses.types';

const TAG = 'courses:courses' as const;

export const coursesEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		listCourses: builder.query<ListCoursesOutput, ListCoursesInput>({
			query: (arg) => ({
				url: 'courses/catalog',
				params: arg
					? {
							...(arg.status === CoursesCourseStatus.Completed
								? { status: CoursesCourseStatus.Completed }
								: {}),
							...(arg.sort ? { sort: arg.sort } : {}),
						}
					: undefined,
			}),
			providesTags: [TAG],
		}),
		getCourse: builder.query<GetCourseOutput, GetCourseInput>({
			query: ({ courseId }) => ({ url: `courses/catalog/${encodeURIComponent(courseId)}` }),
			providesTags: [TAG],
		}),
	}),
});

export const {
	useListCoursesQuery,
	useLazyListCoursesQuery,
	useGetCourseQuery,
	useLazyGetCourseQuery,
} = coursesEndpoints;
